import { render, staticRenderFns } from "./CollectionListDefaultLayout.vue?vue&type=template&id=ebc39f0e&scoped=true&"
import script from "./CollectionListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./CollectionListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc39f0e",
  null
  
)

export default component.exports